let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6GsoP")).then(() => parcelRequire('p1UY9'));